import {
  createTRPCReact,
  type inferReactQueryProcedureOptions,
} from '@trpc/react-query';
import type { ApiRouter } from 'further-api/trpc/routes';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

export type ReactQueryOptions = inferReactQueryProcedureOptions<ApiRouter>;
export type ApiInputs = inferRouterInputs<ApiRouter>;
export type ApiResponses = inferRouterOutputs<ApiRouter>;

const trpcClient = createTRPCReact<ApiRouter>();

export const TrpcProvider = trpcClient.Provider;

export default trpcClient;
